import { ShippingCourier } from './shipping-label.models';

/**
 * Gets the logo path for a given shipping courier.
 * @param shippingCourier The shipping courier to get the logo for.
 * @returns The path to the logo image for the shipping courier.
 */
export function getShippingCourierLogoPath(shippingCourier: ShippingCourier): string {
  const basePath = 'assets/images/shipping-couriers-logos/';
  switch (shippingCourier) {
    case ShippingCourier.CEX:
      return basePath + 'correos.jpg';
    case ShippingCourier.MRW:
      return basePath + 'mrw.jpg';
    case ShippingCourier.GLS:
      return basePath + 'gls.png';
    case ShippingCourier.CORREOS:
      return basePath + 'correos.jpg';
    case ShippingCourier.INPOST:
      return basePath + 'inpost.png';
    default:
      return '';
  }
}

/**
 * Gets the display name for a given shipping courier.
 * @param shippingCourier The shipping courier to get the display name for.
 * @returns The display name of the shipping courier.
 */
export function getShippingCourierDisplayName(shippingCourier: ShippingCourier): string {
  switch (shippingCourier) {
    case ShippingCourier.CEX:
      return 'Correos';
    case ShippingCourier.MRW:
      return 'MRW';
    case ShippingCourier.GLS:
      return 'GLS';
    case ShippingCourier.CORREOS:
      return 'Correos';
    case ShippingCourier.INPOST:
      return "InPost";
    default:
      return '';
  }
}
